export enum RunningShipmentCheckType {
  Driver = 'DRIVER',
  Truck = 'TRUCK'
}
